<div class="progress" style="margin-bottom: 0px;">
  <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="Value * 100"
    aria-valuemin="0" aria-valuemax="100" [style.width]="Value * 100 +'%'">
    {{Value * 100}}% Pass Rate
  </div>
</div>